module.exports = "/_next/static/images/95baaebf46403c7f9203353ee4b62163-YourMoneyIsGrowing.png";